import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';
import defaultView from './defaultView';
/* IMPORT HERE */

const uploader: ThemeUICSSObject = {
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  gap: spacing(2),
  '&>div': {
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundSize: '200% 200%',
    flex: '1',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed #999',
    ':focus': {
      ...focusOutline,
      outlineOffset: '-3px',
      border: '0',
    },
    '.uploader__drop-message': {
      alignItems: 'center',
      justifyContent: 'center',
      p: spacing(0),
      fontWeight: 'bold',
      textAlign: 'center',
    },
    '.uploader__uploaded-message': {
      alignItems: 'center',
      justifyContent: 'center',
      p: spacing(0),
      textAlign: 'center',
      flexDirection: 'column',
    },
  },
  '&>ul': {
    p: spacing(0),
    m: spacing(0),
    listStyle: 'none',
    height: '100%',
    width: '100%',
    '&>li': {
      height: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'flex-start',
      gap: spacing(2),
      '&>img': {
        width: '100%',
        mb: spacing(2),
      },
      '.uploader-list__buttons': {},
      '.uploader-list__filename': {
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        fontWeight: 'bold',
        mt: spacing(0),
        mb: spacing(0),
      },
    },
  },

  defaultView,
  /* PREPEND HERE */
};

export default uploader;
